// import { Button, Col, Row } from 'antd';
import React, { useState,useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import LayoutComponent from '../../LayoutComponent';
import '../classroomPayment/classpayment.css'
import Commonregcomponent from '../commonComponent/Commonregcomponent';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './classpayment.css';
// import '../../VenuePayment/VenuePayment.css';
import Payment from '../../VenuePayment/Payment';
import commonLib from "../../control/commonLib";
import Notification from '../../Notification';
import Services from '../../network/Services';
import konsole from '../../network/konsole';


const Classroomvenupayment = (props) => {
  // const location = useLocation()
  

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [showPayment, setshowPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('')
  const seminarObj = commonLib.getObjFromStorage("seminarObj");
  const seminarObj1 = commonLib.getObjFromStorage("readcalssroom");
  const bookedSeats = (props.location.state !== undefined) ? props.location.state : [];
  const selectedUser  = (props.location.state !== undefined) ? props.location.state : {};
  const [warning, setWarning] = useState()
    const [Color1, setColor1] = useState("")
  
    const [showModal , setShowModal] = useState(false) 
    const [popsStatus, setPopsStatus] = useState()
    useEffect(()=>{
      if(popsStatus == false){
        setshowPayment(false)
      }else{
        setPopsStatus(true)
  
      }
  
    },[popsStatus])
  


  konsole.log("ssfdd",selectedUser)
  
  const handlePaymentMethod = (selectedPaymentMethod, method) => {
    // konsole.log("selectedPaymentmethod", selectedPaymentMethod, method);
    setSelectedPaymentMethod(selectedPaymentMethod);
    setPaymentMethod(method)

  }
  // const classRoomRegistration =(userId,seminarAttendeeId,classroomId,createdBy)=>{
  //   let postData = Services.postClassRoomRegister(userId,seminarAttendeeId,classroomId,createdBy)
  //   postData.then((res) => {

   
  //     konsole.log("responseresponse", res.data.data)

  //   }).catch((err) => {
  //     // konsole.log("err", err)
  //   })
  // }
  const handlepayment = () => {
  
    if (paymentMethod == '' || paymentMethod == null) {
   
      setWarning("Please select  payment method")
            setColor1("#ffcc00")
            setShowModal(true)
      // commonLib.setDatatoSession("classroomStaus", JSON.stringify(ClassroomStatus) )
      return;
    } else {
      // classRoomRegistration(userId,seminarAttendeeId,classroomId,createdBy)
      setshowPayment(true)
      setPopsStatus(true)
      // setTimeout(() => {
      //   setshowPayment(false)
      // }, 90000)
    }
  }
  let formatPhoneNumber = (str) => {
    //Filter only numbers from the input
    let cleaned = ("" + str).replace(/\D/g, "");

    //Check if the input is of correct length
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  };

  return (
    <div>
      <LayoutComponent>
      <Notification showModal={showModal} message={warning} color={Color1} setShowModal={setShowModal}/>

      <div className=' container-fluid bgclr' >
        <div className='row'>
          <div className='col-sm-6 mt-3'>
          <h4>Workshop Registration: Payment<b> </b></h4>
           
            <p className='fs-5'>Topic :
             {seminarObj?.seminarTopic}
             </p>
          </div>
        </div>
        <div className='container-fluid d-flex justify-content-center align-items-center ' >
          <div className='col-sm-12 bg-white d-flex flex-column flex-md-row p-0 p-md-2' >
            <div className='col-xs-4 border-end'>
              <div className='ms-4 m-ms-md-0'>
                <dl className="user-Details-Div">
                  <h3><b>User Details</b></h3>
                  < div className="dt fs-5">First name :{
                            // seminarObj1 === true 
                            selectedUser?.selectedUser?.attendeeFullName 
                            // :selectedUser.selectedUser.selectedUser.attendeeFullName 
                } <span className="text-secondary">
               
                  </span> </div>
                  <dd id="lblName"></dd>
                  <div className="dt fs-5">Email :{
                  // seminarObj1 === true?
                   selectedUser.selectedUser.attendeeEmailAddress 
                  //  : selectedUser.selectedUser.selectedUser.attendeeEmailAddress
                    } <span className='text-secondary'>
                 
                  </span></div>
                  <dd id="lblId"></dd>
                  <div className="dt fs-5">Cell Number : 
                        {
                        selectedUser.selectedUser?.attendeeMobileNo.toString().slice(0,-10) } 
                          { " "}
                           {formatPhoneNumber(selectedUser.selectedUser?.attendeeMobileNo.toString().slice(-10))
                           }
              
                 {/* {selectedUser.selectedUser.attendeeMobileNo } */}
                  
                  <span className='text-secondary'>
                
                  </span></div>
                  <dd id="lblId"></dd>
             
                  <dd id="lblAmenities"></dd>
                </dl>
                <dl className="user-Details-Div">
                  <h3><b>Workshop Details</b></h3>
                  < div className="dt fs-5">Workshop name :{selectedUser?.selectedUserObj?.seminarTopic} <span className="text-secondary">
             
                  </span> </div>
                  <dd id="lblName"></dd>
                  <div className="dt fs-5">Selected Date:
            
                  {commonLib.getFormattedDate(selectedUser?.selectedUserObj?.seminarDate)}
                  <span className='text-secondary'>
              
                  </span></div>
                  <dd id="lblId"></dd>
                  <div className="dt fs-5">Selected Time : 
           {commonLib.getFormattedTime(selectedUser?.selectedUserObj?.seminarTime)}
                  <span className='text-secondary'>
               
                  </span></div>
                  <dd id="lblId"></dd>
                  < div className="dt fs-5" >Fee:$ {selectedUser?.selectedUserObj?.seminarFee}
                     
                   <span className='text-secondary'>
                    {/* {selectedUser.data1?.semUserStatusId === 3 && 4 ? `$${selectedUser.data2 * selectedUser.userRegistration.noOfAttendee}`:"$500"} */}
                    </span></div>
                  <dd id="lblAmenities"></dd>
                </dl>
              </div>
            </div>
            <div className='col-12 col-md-6 ps-4' >
              <h4> Choose a Payment Method</h4>
              <div className='row'>
                <div className="col-10 col-md-4 p-2 cursor-pointer" onClick={() => handlePaymentMethod(1, 'Card')}>
                  <div class="card">
                    <div class={`${(selectedPaymentMethod === 1) ? "seletectedIndexBackground" : ''} card-body text-center rounded `}>
                      <h5 class="card-title "><img src={`${(selectedPaymentMethod === 1) ? '/icons/creditActiveIcon.svg' : '/icons/creditcardPayment.svg'}`} /></h5>
                      <p className='fw-bold'> Credit/Debit Card</p>
                    </div>
                  </div>
                </div>
                {/* <div className="col-10 col-md-4 p-2 cursor-pointer" onClick={() => handlePaymentMethod(2, "Paypal")}>
                  <div class="card">
                    <div class={`${(selectedPaymentMethod === 2) ? "seletectedIndexBackground" : ''} card-body text-center rounded `}>
                      <h5 class="card-title"><img src={`${(selectedPaymentMethod === 2) ? '/icons/paypalActiveIcon.svg' : '/icons/paypal.svg'}`} /></h5>
                      <p className=' fw-bold'>Paypal</p>
                    </div>
                  </div>
                </div> */}
                <div className="col-10 col-md-4 p-2 cursor-pointer" onClick={() => handlePaymentMethod(3, "Cash")}>
                  <div class="card ">
                    <div class={`${(selectedPaymentMethod === 3) ? "seletectedIndexBackground" : ''} card-body text-center rounded `}>
                      <div class="">
                        <h5 className='card-title'><img src={`${(selectedPaymentMethod === 3) ? '/icons/cashActiveIcon.svg' : '/icons/cashPayment.svg'}`} /></h5>
                        <span className='fw-bold'>Cash</span>
                        <p className='vanu-counter'> </p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className='text-center col-6 m-auto mt-5 pb-4'>
                {/* <button type='text' className='px-4 py-1 theme-btn rounded text-center ' onClick={handlePostPayment}>Make Payment</button> */}
                <button type='text' className='px-4 py-1 theme-btn rounded text-center ' onClick={handlepayment}> Payment</button>

              </div>
            </div>
          </div>
        </div>
      </div >
      <>



        {
          showPayment ? <Payment selectedUser1={selectedUser}paymentMethod={paymentMethod}setPopsStatus={setPopsStatus} /> : ''
        }

      </>



    </LayoutComponent>
    </div>
  )
}

export default Classroomvenupayment




